var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "textarea",
      class: {
        "textarea--filled": !!_vm.value,
        "textarea--error": _vm.error.length,
        "textarea--icon-left": _vm.iconPosition === "left",
        "textarea--icon-right": _vm.iconPosition === "right",
      },
    },
    [
      _c("span", { staticClass: "textarea__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c("span", { staticClass: "textarea__container" }, [
        _vm.iconPosition
          ? _c(
              "button",
              {
                staticClass: "textarea__action",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("action")
                  },
                },
              },
              [
                _vm._t("icon", function () {
                  return [_c("IconComponent", { attrs: { name: "search" } })]
                }),
              ],
              2
            )
          : _vm._e(),
        _c("textarea", {
          directives: [
            {
              name: "mask",
              rawName: "v-mask",
              value: _vm.mask,
              expression: "mask",
            },
          ],
          ref: "textarea",
          staticClass: "textarea__field",
          attrs: { placeholder: _vm.placeholder, rows: _vm.rows },
          domProps: { value: _vm.value },
          on: {
            input: _vm.handleInput,
            blur: function ($event) {
              return _vm.$emit("blur", $event)
            },
          },
        }),
      ]),
      _vm.subtitle
        ? _c("span", { staticClass: "textarea__subtitle" }, [
            _vm._v(_vm._s(_vm.subtitle)),
          ])
        : _vm._e(),
      _vm.error && _vm.error.length
        ? _c(
            "ul",
            { staticClass: "textarea__error" },
            _vm._l(_vm.error, function (e, i) {
              return _c("li", { key: i }, [_vm._v(_vm._s(e))])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }